export const axios = require('axios');
// export const HOST = process.env.NODE_ENV === 'production' ? '' : `http://127.0.0.1:8080`; //`http://localhost:8080`;
export const HOST =  process.env.VUE_APP_BACKEND_HOST

export let config = {
  withCredentials: true,
  headers: {
    Authorization: window.sessionStorage.getItem('token'),
    ServiceType : process.env.VUE_APP_SERVICE
  }
};

export function setTokenConfig(token, refreshToken) {
  window.sessionStorage.setItem('token', token)
  window.sessionStorage.setItem('refreshToken', refreshToken)
  config.headers.Authorization = window.sessionStorage.getItem('token')
}

import moment from 'moment';
let isDoingReissueToken = false;
let waitList = [];

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {

    const token = window.sessionStorage.getItem('token');
    const refresh = window.sessionStorage.getItem('refreshToken');

    let originError = error;
    // 403에러 상황에서 token 만료, refreshToken 유효한 경우 재요청
    if(originError.response.status ===  403 && !isValidToken(token) && refresh != null && isValidToken(refresh)) {

      const originalReq = originError.config;

      const error = new Promise((resolve) => {
        addWaitList((accessToken) => {
          originalReq.headers.Authorization = accessToken;
          resolve(axios(originalReq));
        });
      });

      // 토큰재발급이 진행중인상태이면, waitList에 추가.
      if(!isDoingReissueToken) {
        isDoingReissueToken = true;
        let reissueConfig = config;
        reissueConfig.headers.Authorization = sessionStorage.getItem('refreshToken')
        const res = await axios.post(`${HOST}/reissue`, null, reissueConfig);
        //재발급한 토큰 저장
        const newToken = res.data;
        sessionStorage.setItem('token', newToken);
        config.headers.Authorization = newToken;

        isDoingReissueToken = false;
        onTokenRefreshed(newToken);
      }
      return error;
    }

    //403이 아니거나, 리프레시토큰도 만료된 경우에는 서버에서 받은 originError 리턴
    return Promise.reject(originError);
  }
)

const onTokenRefreshed = (accessToken) => {
  waitList.map((callback) => callback(accessToken));
  waitList = [];
};

const addWaitList = (callback) => {
  waitList.push(callback);
};

function isValidToken(token) {
  const payload = JSON.parse(atob(token.split('.')[1]));
  const cur = moment().unix()
  const exp = payload.exp

  return (moment(exp).isAfter(cur));
}